<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div>
    <!--     value: {{ value }} <br>
    selectedValues: {{ test }} <br>
      facet: {{ facet }} <br>
      unavailableFacets: {{ unavailableFacets }} <br>

      facetSettings: {{ facetSettings }}
      selectedValues: {{ selectedValues }}
      search: {{ search }} -->

    <!-- @input="search = ''" -->
    <v-autocomplete
      v-model="selectedValues"
      :type="type"
      :search-input.sync="searchQuery"
      :loading="loading"
      item-text="label"
      item-value="value"
      :filter="filter"
      :hide-no-data="loading"
      :items="listItems"
      hide-selected
      label="Valeur"
      :multiple="multiple"
      return-object
      chips
      color="blue"
      clearable
      :disabled="disabled"
      item-color="info"
      menu-props="light"
      :rules="rules"
      @focus="focus"
      @keyup="keyup"
      @input="select"
    >
      <template #no-data>
        <v-list-item>
          <v-chip
            color="lighten-3"
            label
            small
          >
            {{ searchQuery }}
          </v-chip>
          <span class="subheading ml-1 mr-2">not found</span>
          <v-btn
            v-if="freeField"
            outlined
            @click.stop="addValue"
          >
            Add
          </v-btn>
        </v-list-item>
      </template>
      <template #selection="{ attrs, item, index, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          color=" lighten-3`"
          :input-value="selected"
          label
          small
        >
          <span class="pr-2">
            {{ item.label }}
          </span>
          <v-icon
            small
            @click.stop="removeValue(index)"
          >
            $delete
          </v-icon>
        </v-chip>
      </template>
      <template #item="{ index, item }">
        <v-chip
          color="lighten-3"
          dark
          label
          small
        >
          {{ item.label }}
        </v-chip>
      </template>
      <template v-if="facet && allowCopy" #append-outer>
        <v-btn
          icon
          @click="openCopyPastePopup"
        >
          <v-icon>mdi-clipboard-text-multiple</v-icon>
        </v-btn>
      </template>
    </v-autocomplete>
  </div>
</template>

<script setup>

import { ref, computed, watch, onMounted, defineEmits } from 'vue';

import { useStore } from 'vue2-helpers/vuex';

import { useApolloClient } from '@vue/apollo-composable';
import { getGraphqlSchema } from '@/graphql/index';

import { EventBus } from '@/mixins';

const { resolveClient } = useApolloClient();

const props = defineProps({
  value: { type: [Array, Object], default: null },
  facet: { type: String, default: null },
  allowCopy: { type: Boolean, default: false },
  searchByQuery: { type: Boolean, default: false },
  freeField: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  multiple: { type: Boolean, default: true },
  type: { type: String, default: 'text' },
  rules: { type: Array, default: () => [] }
});

const selectedValues = ref(props.value); //  || []
const searchQuery = ref('');
const loading = ref(false);
const items = ref([]);
const store = useStore();

const ruleContexts = computed(() => store.state.rules.contextsSelect);

const listItems = computed(() => items.value.concat(selectedValues.value));

const emit = defineEmits(['input']);

const copyPasteValues = pasteValues => {
  pasteValues.forEach(pasteValue => {
    // check if selectItems exist or start
    if (selectedValues.value && selectedValues.value.length) {
      // check if copy paste item is already select
      if (!selectedValues.value.find(o => o.value === pasteValue.value)) {
        selectedValues.value.push(pasteValue);
      }
    } else {
      selectedValues.value.push(pasteValue);
    }
  });
};

let observable = null;

const searchAlgoliaFacetValues = (facet, query = null) => {
  items.value = [];
  loading.value = true;

  const apollo = resolveClient();

  if (observable) {
    observable.unsubscribe();
  }

  const watchedQuery = apollo.watchQuery({
    query: getGraphqlSchema('searchAlgoliaFacetValues'),
    variables: {
      query: query || '',
      facet: facet || '',
      contexts: ruleContexts.value
    }
    // fetchPolicy: 'no-cache'
  });

  // Subscribe to it, and do something with the data
  observable = watchedQuery.subscribe(({ data }) => {
    // facetsItems.value = facetsItems.value.concat(data.searchAlgoliaFacetValues.facetsItems);
    loading.value = false;
    items.value = data.searchAlgoliaFacetValues.facetsValues.map(i => ({
      value: i.value,
      label: i.label
    }));
  });
};

const openCopyPastePopup = () => {
  EventBus.$on('copyPasteValues', copyPasteValues);
  EventBus.$emit('showCopyPastePopup');
};

const filter = (item, queryText, itemText) => {
  if (item.header) return false;
  // console.log(item.label, queryText, itemText);

  const hasValue = val => (val != null ? val : '');

  const text = hasValue(itemText);
  const query = hasValue(queryText);

  return text.toString()
    .toLowerCase()
    .indexOf(query.toString().toLowerCase()) > -1;
};

// onMounted(() => {
//   if (props.facet) {
//     searchAlgoliaFacetValues(props.facet);
//   }
// });

watch(() => searchQuery.value, val => {

  if (props.searchByQuery || (!listItems.value.length && props.facet)) {
    searchAlgoliaFacetValues(props.facet, val);
  }
}, { deep: true });

// watch(() => props.facet, val => {
//   if (props.facet) {
//     selectedValues.value = [];
//     searchQuery.value = '';
//     searchAlgoliaFacetValues(props.facet, val);
//   }
// }, { deep: true });

watch(() => selectedValues.value, val => {
  emit('input', val);
}, { deep: true });

watch(() => props.value, val => {
  selectedValues.value = val;
}, { deep: true });

const addValue = () => {
  const item = { value: searchQuery.value, label: searchQuery.value };
  if (props.multiple) {
    selectedValues.value.push(item);
  } else {
    selectedValues.value = item;
  }
  searchQuery.value = '';
};

const removeValue = index => {
  if (props.multiple) {
    selectedValues.value.splice(index, 1);
  } else {
    selectedValues.value = null;
  }
};

const focus = () => {
  if (props.facet) {
    searchQuery.value = '';
    searchAlgoliaFacetValues(props.facet);
  }
};

const querySearch = () => {
  if (props.searchByQuery || (!listItems.value.length && props.facet)) {
    searchAlgoliaFacetValues(props.facet, searchQuery.value);
  }
};

const keyup = val => {
  querySearch();
};

const select = () => {
  searchQuery.value = '';
  querySearch();
};

</script>
